import React from 'react'
import { Helmet } from 'react-helmet'
import { CLOUDFRONT_BASE_URL } from './index'

const CLIENT_FONTS_SCRIPTS = {
  lifexperiences: {
    fontsLinks: (
      <Helmet>
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
        <link
          href='https://ds-cdn.prod-east.frontend.public.atl-paas.net/assets/font-rules/v5/atlassian-fonts.css'
          rel='stylesheet'
          crossorigin
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..600;1,100..600&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  flytrip: {
    fontsLinks: (
      <Helmet>
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
        <link
          href='https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100..900;1,100..900&family=Sofia&family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  bestarctic: {
    fontsLinks: (
      <Helmet>
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
        <link
          href='https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  holapola: {
    fontsLinks: (
      <Helmet>
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
        <link
          href='https://fonts.googleapis.com/css2?family=Carlito:ital,wght@0,400;0,700;1,400;1,700&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  plugplugtravel: {
    fontsLinks: (
      <Helmet>
        {/* FONT MULISH */}
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
        <link
          href='https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100..900;1,100..900&family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  zoover: {
    customFonts: [
      {
        fontFamily: 'Averta',
        src: `${CLOUDFRONT_BASE_URL}/assets/zoover/fonts/4c1eb633de3af1ce-s.p.woff2`,
      },
    ],
  },
  neckermann: {
    fontsLinks: (
      <Helmet>
        <link
          href='https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700&display=swap'
          rel='stylesheet'
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;0,800;1,400&display=swap'
          rel='stylesheet'
          type='text/css'
        />
      </Helmet>
    ),
  },
  bunkhouse: {
    fontsLinks: (
      <Helmet>
        {/* FONT MULISH */}
        <link
          href='https://fonts.googleapis.com/css2?family=Mulish:wght@400;600;700;800&display=swap'
          rel='stylesheet'
        />
        {/*  FONT SOURCE SANS PRO */}
        <link
          href='https://fonts.googleapis.com/css?family=Source+Sans+Pro'
          rel='stylesheet'
          type='text/css'
        />
      </Helmet>
    ),
    customFonts: [
      {
        fontFamily: 'Aktiv',
        src: `${CLOUDFRONT_BASE_URL}/assets/bunkhouse/fonts/AktivGrotesk-Regular.ttf`,
      },
    ],
  },
  emaar: {
    fontsLinks: (
      <Helmet>
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
        <link
          href='https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  travelbase: {
    fontsLinks: (
      <Helmet>
        <link
          href='https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;0,800;1,400&display=swap'
          rel='stylesheet'
          type='text/css'
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Mulish:wght@400;600;700;800&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
    customFonts: [
      {
        fontFamily: 'sofia-pro',
        src: `${CLOUDFRONT_BASE_URL}/assets/travelbase/fonts/sofia-pro-regular.woff2`,
      },
      {
        fontFamily: 'filson-pro',
        src: `${CLOUDFRONT_BASE_URL}/assets/travelbase/fonts/FilsonProRegular.otf`,
      },
    ],
  },
  joker: {
    fontsLinks: <Helmet></Helmet>,
    customFonts: [
      {
        fontFamily: 'museo sans',
        src: `${CLOUDFRONT_BASE_URL}/assets/joker/fonts/MuseoSans_500.otf`,
      },
      {
        fontFamily: 'museo slab',
        src: `${CLOUDFRONT_BASE_URL}/assets/joker/fonts/MuseoSlab_500.otf`,
      },
    ],
  },
  frenchmorning: {
    fontsLinks: (
      <Helmet>
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
        <link
          href='https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap'
          rel='stylesheet'
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..600;1,100..600&display=swap'
          rel='stylesheet'
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Crimson+Text:ital,wght@0,400;0,600;0,400;1,600&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  frenchmorningcanada: {
    fontsLinks: (
      <Helmet>
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
        <link
          href='https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap'
          rel='stylesheet'
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..600;1,100..600&display=swap'
          rel='stylesheet'
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Crimson+Text:ital,wght@0,400;0,600;0,400;1,600&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  frenchmorninglondon: {
    fontsLinks: (
      <Helmet>
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
        <link
          href='https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap'
          rel='stylesheet'
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..600;1,100..600&display=swap'
          rel='stylesheet'
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Crimson+Text:ital,wght@0,400;0,600;0,400;1,600&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  tripandstuff: {
    fontsLinks: (
      <Helmet>
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
        <link
          href='https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;1,100;1,200;1,300;1,400;1,500;1,600;&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  isbjorn: {
    fontsLinks: <Helmet></Helmet>,
  },
  haystravel: {
    fontsLinks: (
      <Helmet>
        <link
          href='https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;0,800;1,400&display=swap'
          rel='stylesheet'
          type='text/css'
        />
      </Helmet>
    ),
  },
  dawsonandsanderson: {
    fontsLinks: (
      <Helmet>
        <link
          href='https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;0,800;1,400&display=swap'
          rel='stylesheet'
          type='text/css'
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Mulish:wght@400;600;700;800&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  nazar: {
    fontsLinks: (
      <Helmet>
        <link
          href='https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;0,800;1,400&display=swap'
          rel='stylesheet'
          type='text/css'
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Mulish:wght@400;600;700;800&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  aktiefski: {
    fontsLinks: (
      <Helmet>
        <link
          href='https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;0,800;1,400&display=swap'
          rel='stylesheet'
          type='text/css'
        />
      </Helmet>
    ),
  },
  laplandtravel: {
    fontsLinks: (
      <Helmet>
        <link
          rel='stylesheet'
          href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css'
        ></link>
      </Helmet>
    ),
    customFonts: [
      {
        fontFamily: 'sofia-pro',
        src: `${CLOUDFRONT_BASE_URL}/assets/laplandtravel/fonts/Sofia_Pro_Regular_Az.otf`,
      },
      {
        fontFamily: 'filson-pro',
        src: `${CLOUDFRONT_BASE_URL}/assets/laplandtravel/fonts/FilsonProRegular.otf`,
      },
    ],
  },
  thegreenprogram: {
    fontsLinks: (
      <Helmet>
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
        <link
          href='https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  demo: {
    fontsLinks: (
      <Helmet>
        <link
          href='https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;0,800;1,400&display=swap'
          rel='stylesheet'
          type='text/css'
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Mulish:wght@400;600;700;800&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  frenchly: {
    customFonts: [
      {
        fontFamily: 'Canela',
        src: `${CLOUDFRONT_BASE_URL}/assets/frenchly/fonts/Canela.ttf`,
      },
      {
        fontFamily: 'VisbyCF-Regular',
        src: `${CLOUDFRONT_BASE_URL}/assets/frenchly/fonts/VisbyCF-Regular.otf`,
      },
    ],
  },
  zuiderhuis: {
    fontsLinks: (
      <Helmet>
        <link
          href='https://fonts.googleapis.com/css?family=Spectral'
          rel='stylesheet'
          type='text/css'
        />
        <link
          href='https://fonts.googleapis.com/css?family=Source+Sans+Pro'
          rel='stylesheet'
          type='text/css'
        />
        <link
          rel='stylesheet'
          href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css'
        ></link>
      </Helmet>
    ),
  },
  levelovoyageur: {
    fontsLinks: (
      <Helmet>
        {/*  FONT Trebuchet MS */}
        <link
          href='https://fonts.googleapis.com/css2?family=Helvetica&display=swap'
          rel='stylesheet'
        />
      </Helmet>
    ),
  },
  noorderhuis: {
    fontsLinks: (
      <Helmet>
        {/* FONT MULISH */}
        <link
          href='https://fonts.googleapis.com/css2?family=Mulish:wght@400;600;700;800&display=swap'
          rel='stylesheet'
        />
        {/*  FONT SOURCE SANS PRO */}
        <link
          href='https://fonts.googleapis.com/css?family=Source+Sans+Pro'
          rel='stylesheet'
          type='text/css'
        />
      </Helmet>
    ),
  },
  kingfisher: {
    fontsLinks: (
      <Helmet>
        <link
          href='https://fonts.googleapis.com/css?family=Lato'
          rel='stylesheet'
          type='text/css'
        ></link>
      </Helmet>
    ),
  },
  odysseus: {
    fontsLinks: (
      <Helmet>
        <link
          href='https://fonts.googleapis.com/css?family=Alegreya+Sans+SC'
          rel='stylesheet'
          type='text/css'
        ></link>
      </Helmet>
    ),
  },
  odysseus_b2b: {
    fontsLinks: (
      <Helmet>
        <link
          href='https://fonts.googleapis.com/css?family=Alegreya+Sans+SC'
          rel='stylesheet'
          type='text/css'
        ></link>
      </Helmet>
    ),
  },
}

// RETURN CLIENT FONTS SCRIPTS TO DOWNLOAD
export const getClientSpecificScripts = slug => {
  if (!slug || !CLIENT_FONTS_SCRIPTS[slug]) return null

  let clientConfig = CLIENT_FONTS_SCRIPTS[slug]

  if (clientConfig.customFonts) {
    for (let fontConfig of clientConfig.customFonts) {
      const style = document.createElement('style')
      style.appendChild(
        document.createTextNode(`
          @font-face {
            font-family: '${fontConfig.fontFamily}';
            src: url('${fontConfig.src}') format('woff2');
            /* Add more src entries if you have different font file formats */
          }
        `)
      )
      document.head.appendChild(style)
    }
  }

  if (clientConfig.fontsLinks) {
    return CLIENT_FONTS_SCRIPTS[slug].fontsLinks
  }

  return null
}
